'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotTimeSeriesIcon = function PlotTimeSeriesIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M1.938 16.188c.125-.438.25-.938.438-1.438.5-1.5 1.063-3 1.75-4.438 1.75-3.875 3.625-6.188 5.375-6.188 1.625 0 3.063 1.625 6 6.25 3.25 5.125 4.75 6.813 7 6.813 2.438 0 4.563-2.563 6.5-6.875.625-1.438 1.25-3 1.75-4.563.188-.5.313-1 .5-1.438.063-.313.125-.5.125-.625l-1.125-.313c-.063.125-.063.313-.188.563-.125.438-.25.938-.438 1.438-.5 1.563-1.063 3.063-1.75 4.438C26.125 13.687 24.25 16 22.5 16c-1.625 0-3.063-1.563-6-6.25-3.25-5.125-4.75-6.813-7-6.813-2.438 0-4.563 2.625-6.5 6.875-.625 1.438-1.25 3-1.75 4.563-.188.563-.313 1.063-.5 1.5-.063.25-.125.438-.125.563l1.125.313c.063-.125.063-.313.188-.563zM.75 4.313c.188.438.313.938.5 1.438.5 1.563 1.125 3.125 1.75 4.563 1.938 4.313 4.063 6.875 6.5 6.875 2.25 0 3.75-1.688 7-6.813 2.938-4.625 4.375-6.25 6-6.25 1.75 0 3.625 2.313 5.375 6.188.688 1.438 1.25 2.938 1.75 4.438.188.5.313 1 .438 1.438.125.25.125.438.188.563l1.125-.313c0-.125-.063-.313-.125-.563-.188-.438-.313-.938-.5-1.5-.5-1.563-1.125-3.125-1.75-4.563-1.938-4.25-4.063-6.875-6.5-6.875-2.25 0-3.75 1.688-7 6.813-2.938 4.688-4.375 6.25-6 6.25-1.75 0-3.625-2.313-5.375-6.188-.688-1.375-1.25-2.875-1.75-4.438-.188-.5-.313-1-.438-1.438-.125-.25-.125-.438-.188-.563l-1.125.313c0 .125.063.313.125.625zM0 23.688h7.125v5.938H0zm22.5 0H32v5.938h-9.5zm-15.375 0H22.5v1.188H7.125zm0 4.75H22.5v1.188H7.125z' })
    );
};

exports.default = PlotTimeSeriesIcon;